import script from "./VideoUploaderSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoUploaderSection.vue?vue&type=script&lang=ts&setup=true"

import "./VideoUploaderSection.vue?vue&type=style&index=0&id=78309f45&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78309f45"]])

export default __exports__